<template>
  <div>
    <van-button class="btn" round color="#f85b0f" @click="signOutOidc">退出登录</van-button>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "",
  data() {
    return {};
  },
  components: {},
  computed: {},
  methods: {
    ...mapActions({
      signOutOidc: "signOutOidc"
    })
  }
};
</script>

<style scoped lang="scss">
div {
  text-align: center;
}
.btn {
  margin-top: calc(50% - 20px);
}
</style>
